import { OnlineSchedulingConstants } from 'lib/constants/online-scheduling';
import {
  OnlineSchedulingContextProps,
  OnlineSchedulingDispatchAction,
} from './OnlineSchedulingTypes';

export function onlineSchedulingReducer(
  onlineSchedulingContextProps: OnlineSchedulingContextProps,
  action: OnlineSchedulingDispatchAction
) {
  if (!action?.type) {
    return onlineSchedulingContextProps;
  }

  switch (action.type) {
    case OnlineSchedulingConstants.setIsLoading: {
      return {
        ...onlineSchedulingContextProps,
        isLoading: action.result,
      };
    }
    case OnlineSchedulingConstants.initialLeadData: {
      return {
        ...onlineSchedulingContextProps,
        isInline: action.result?.isInline ?? false,
        iframeHostDomain: action.result?.osDomain,
        primarySubmissionData: action.result?.leadData,
      };
    }
    case OnlineSchedulingConstants.primarySubmission: {
      return {
        ...onlineSchedulingContextProps,
        primarySubmissionResponse: action.result?.submissionResponse,
        primarySubmissionData: action.result?.submissionData,
      };
    }
    case OnlineSchedulingConstants.secondarySubmission: {
      return {
        ...onlineSchedulingContextProps,
        secondarySubmissionResponse: action.result,
      };
    }
    case OnlineSchedulingConstants.tertiarySubmission: {
      return {
        ...onlineSchedulingContextProps,
        tertiarySubmissionResponse: action.result,
      };
    }
    default: {
      return onlineSchedulingContextProps;
    }
  }
}
